import { PhotoshopController } from '../photoshopController.js';
import * as glMatrix from 'gl-matrix';
import tinycolor from 'tinycolor2';

export class ColorsWidget {
    parentElement: HTMLElement;
    photoshopController: PhotoshopController;
    constructor(parentElement: HTMLElement, controller: PhotoshopController) {
        this.parentElement = parentElement;
        this.photoshopController = controller;
    }

    static html() {
        return `
        <div class="col s12">
            <h4>Couleur</h4>
            <div class="row">
                <input id="color-picker">
            </div>
        </div>
        <div class="col s12 divider"></div>
        `;
    }

    updateStyle() {
        const selectedColorElement = document.getElementById("selected-color");
        if (this.photoshopController.selectedColor() && selectedColorElement) {
            selectedColorElement.style.backgroundColor = "" + this.photoshopController.selectedColor()["background-color"];
        }
    }

    updateColor = (value) => {
        this.photoshopController.PSColor = glMatrix.vec4.fromValues(value._r, value._g, value._b, value._a);
        try {
            window.localStorage.setItem('PSColor', this.photoshopController.PSColor);
        } catch (e) {
        }
        this.updateStyle();
    }

    initializeColorPicker() {
        ($('#color-picker') as any).spectrum({
            preferredFormat: 'hex',
            color: tinycolor('black'),
            showInput: true,
            flat: true,
            showAlpha: true,
            showButtons: false,
            replacerClassName: 'color-picker',
            move: this.updateColor
        });
    }

    destroy() {
        ($('#color-picker') as any).spectrum('destroy');
    }
}